import { createEffectFn } from '@ngneat/effects';
import { Observable, tap } from 'rxjs';
import { GQLCompany } from '../../generated/gql';
import { setToDefaultGroup } from '../../lib/groups';
import { setToDefaultSite } from '../../lib/sites/sites';
import { execSummaryStore } from '../execSummaryStore';
import { groupStore } from '../groupStore';
import { siteStore } from '../site';
import { systemStore } from '../system/systemStore';
import { setActiveCompany } from './companyStore.actions';
import { analyticsStore } from '../analyticsStore';

export const updateActiveCompanyEffect = createEffectFn(
  (newCompany$: Observable<GQLCompany>) => {
    return newCompany$.pipe(
      tap(() => execSummaryStore.reset()),
      tap(() => systemStore.reset()),
      tap(() => siteStore.reset()),
      tap(() => groupStore.reset()),
      tap(() => analyticsStore.reset()),
      tap(setActiveCompany),
      tap((x) => setToDefaultSite(x.id)),
      tap((x) => setToDefaultGroup(x.id))
    );
  }
);
